import constants from './../../constants'

const isCompany = kind => kind === constants.people.COMPANY

export default isCompany
